import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ element, allowedRoles }) => {
  const user = useSelector((state) => state.currentUser);
  const userRoles = user?.roles || [];

  const hasPermission = allowedRoles.some((role) => userRoles.includes(role));

  return hasPermission ? element : <Navigate to="/new" replace />;
};

export default ProtectedRoute;
